import { render, staticRenderFns } from "./effectDetailFans.vue?vue&type=template&id=a50813ca&scoped=true"
import script from "./effectDetailFans.vue?vue&type=script&lang=js"
export * from "./effectDetailFans.vue?vue&type=script&lang=js"
import style0 from "./effectDetailFans.vue?vue&type=style&index=0&id=a50813ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50813ca",
  null
  
)

export default component.exports